import TypeError from '.TypeError';

import * as TOKEN from './TOKEN';
import Layer, { protect } from './Layer';

const STATE_BEFORE_NAME = 1         ;
const STATE_DURING_NAME = 2         ;
const STATE_NAME_SPACE = 3         ;
const STATE_PREFIX = 4         ;
const STATE_AFTER_NAME = 5         ;
const STATE_DURING_OP = 6         ;
const STATE_AFTER_OP = 7         ;
const STATE_VALUE = 8         ;
const STATE_CASE = 9         ;

export default class AttributeSelector extends Layer         {
	
	get [Symbol.toStringTag] () { return 'AttributeSelector'; }
	
	constructor () { return TOKEN.currentLayer ? TOKEN.collection_attribute[TOKEN.collection_attribute.length] = super()                    : super()                   ; }
	
	nameLiteral         = '';
	        _state                                        = STATE_BEFORE_NAME;/// ,
	
	[TOKEN.consume] (                       ) {
		switch ( this._state ) {
			case STATE_BEFORE_NAME:
				switch ( TOKEN.type ) {
					case TOKEN.ident:
						this._state = STATE_DURING_NAME;
						this.nameLiteral = TOKEN.literal;
						return this;
					case '*':
						this._state = STATE_NAME_SPACE;
						this.nameLiteral = TOKEN.literal;
						return this;
					case '|':
						this._state = STATE_PREFIX;
						this.nameLiteral = TOKEN.literal;
						return this;
					case TOKEN.whitespace:
					case TOKEN.comment:
						return this;
				}
				break;
			case STATE_NAME_SPACE:
				switch ( TOKEN.type ) {
					case '|':
						this._state = STATE_PREFIX;
						this.nameLiteral += TOKEN.literal;
						return this;
					case TOKEN.comment:
						return this;
				}
				break;
			case STATE_PREFIX:
				switch ( TOKEN.type ) {
					case TOKEN.ident:
						this._state = STATE_AFTER_NAME;
						this.nameLiteral += TOKEN.literal;
						return this;
					case TOKEN.comment:
						return this;
				}
				break;
			case STATE_DURING_NAME:
				switch ( TOKEN.type ) {
					case ']':
						this._state = 0;
						return this[TOKEN.parent];
					case '|':
						if ( TOKEN.index!==TOKEN.length && TOKEN.types[TOKEN.index]==='=' ) {
							this._state = STATE_DURING_OP;
							this.newItem = TOKEN.literal;
						}
						else {
							this._state = STATE_PREFIX;
							this.nameLiteral += TOKEN.literal;
						}
						return this;
					case '~':
					case '^':
					case '$':
					case '*':
						this._state = STATE_DURING_OP;
						this.newItem = TOKEN.literal;
						return this;
					case '=':
						this._state = STATE_AFTER_OP;
						this.newItem = TOKEN.literal;
						return this;
					case TOKEN.whitespace:
						this._state = STATE_AFTER_NAME;
						return this;
					case TOKEN.comment:
						return this;
				}
				break;
			case STATE_AFTER_NAME:
				switch ( TOKEN.type ) {
					case ']':
						this._state = 0;
						return this[TOKEN.parent];
					case '|':
					case '~':
					case '^':
					case '$':
					case '*':
						this._state = STATE_DURING_OP;
						this.newItem = TOKEN.literal;
						return this;
					case '=':
						this._state = STATE_AFTER_OP;
						this.newItem = TOKEN.literal;
						return this;
					case TOKEN.whitespace:
					case TOKEN.comment:
						return this;
				}
				break;
			case STATE_DURING_OP:
				switch ( TOKEN.type ) {
					case '=':
						this._state = STATE_AFTER_OP;
						this.newItem = TOKEN.literal;
						return this;
				}
				break;
			case STATE_AFTER_OP:
				switch ( TOKEN.type ) {
					case TOKEN.string:
					case TOKEN.ident:
						this._state = STATE_VALUE;
						this.newItem = TOKEN.literal;
						return this;
					case TOKEN.whitespace:
					case TOKEN.comment:
						return this;
				}
				break;
			case STATE_VALUE:
				switch ( TOKEN.type ) {
					case ']':
						this._state = 0;
						return this[TOKEN.parent];
					case TOKEN.ident:
						this._state = STATE_CASE;
						this.newItem = ' ';
						this.newItem = TOKEN.literal;
						return this;
					case TOKEN.whitespace:
					case TOKEN.comment:
						return this;
				}
				break;
			case STATE_CASE:
				switch ( TOKEN.type ) {
					case ']':
						this._state = 0;
						return this[TOKEN.parent];
					case TOKEN.whitespace:
					case TOKEN.comment:
						return this;
				}
				break;
		}
		return null;
	}
	
	[Symbol.toPrimitive] (                       ) {
		return `[${this.nameLiteral}${this.join('')}]`;
	}
	
	* [Symbol.iterator] (                       ) { throw TypeError(`beautify attributeSelector`); }
	
	                                                
	
	static default = protect(this);
	
};

                                             
                                         